import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ProfileTab from "../../../core/common/profiletab";
import Table from "../../../core/common/dataTable/index";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const FamilyDetails = () => {
  const routes = all_routes;
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;
  const [editData, setEditData] = useState<any>({});
  const [getData, setGetData] = useState(1);
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const columns1 = [
    {
      title: "S.No.",
      dataIndex: "sno",
    },
    {
      title: "Name",
      dataIndex: "first_name",
    },
    {
      title: "Relation",
      dataIndex: "relation",
    },
    {
      title: "Gender",
      dataIndex: "gender",
    },
    {
      title: "Date of Birth",
      dataIndex: "date_of_birth",
    },
    {
      title: "Age",
      dataIndex: "age",
    },
    {
      title: "Birth Place",
      dataIndex: "birthplace",
    },
    {
      title: "Blood Group",
      dataIndex: "blood_group",
    },
    {
      title: "Occupation",
      dataIndex: "occupation",
    },
    {
      title: "Medical Insurance",
      dataIndex: "mediclaim",
      render: (text: string) => (
        <span className={`${text === "Yes" ? "text-success" : "text-danger"}`}>
          {text}
        </span>
      ),
    },
    {
      title: "Aadhar Number",
      dataIndex: "aadhar_no",
      render: (text: string) => <span className="no-wrap">{text}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        const canEdit =
          status === "In Progress" ||
          status === "Rejected" ||
          status === "Re Open" ||
          status === "Not Started";

        return (
          <i
            className={`ti ti-edit ${canEdit ? "text-primary" : "text-secondary"}`}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.6,
            }}
            title={
              canEdit
                ? "Edit"
                : "Editing is disabled for this status"
            }
            onClick={() => {
              if (canEdit) {
                setEditData(record);
              }
            }}
            data-bs-toggle={canEdit ? "modal" : undefined}
            data-bs-target={canEdit ? "#editexampleModalLg" : undefined}
          />
        );
      },
    }

  ];

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    date_of_birth: "",
    age: "",
    blood_group: "",
    gender: "",
    relation: "",
    birthplace: "",
    occupation: "",
    dependants: "",
    mediclaim: "",
    birth_country: "India",
    nationality: "Indian",
    aadhar_no: "",
    address: "",
    id_type: "",
    personal_id: "",
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const getEditData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const {
    data: familyDEpendentData,
    loading: familyDEpendentLoading,
    error: familyDEpendentError,
  } = useApi("/api/onboarding/view-family-dependants", {
    method: "GET",
    autoCall: true,
    dependencies: [getData],
  });

  const addSNo = familyDEpendentData?.data?.map((item: any, index: any) => {
    return {
      ...item,
      sno: index + 1,
    };
  });

  const {
    data: familyData,
    loading,
    error,
    callApi: postFamilyData,
  } = useApi("/api/onboarding/add-family-dependants", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const payload = {
      ...data,
      gender: data.gender.toUpperCase(),
      date_of_birth: dayjs(data.date_of_birth).format("DD/MM/YYYY"),
    };
    try {
      console.log(payload);
      const response = await postFamilyData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data Submited successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
        setGetData(getData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: familyEditData,
    loading: familyEditLoading,
    error: familyEditError,
    callApi: editFamilyData,
  } = useApi("/api/onboarding/edit-family-dependants", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        ...editData,
        dependants_id: editData.ID,
      };
      const response = await editFamilyData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data Submited successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("editcloseModalBtn")?.click();
        });
        setGetData(getData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };
  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Family Details</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Family Details
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div
                  className="stickybar"
                  style={{ position: "sticky", top: "50px" }}
                >
                  <ProfileTab />
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body d-flex justify-content-between">
                    <div className="">
                      <h3>Family Details </h3>
                    </div>
                    {
                      status === "In Progress" || status === "Rejected" || status === "Re Open" || status === "Not Started" ? <button
                        className="btn btn-primary custom_button"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalLg"
                      >
                        <i className="ti ti-circle-plus me-2" />
                        Add New Member
                      </button> : ""
                    }

                  </div>
                  <div className="card">
                    <Table
                      dataSource={addSNo}
                      columns={columns1}
                      Selection={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

      {/* Modal */}
      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Family Details
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                First Name<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your first name"
                                name="first_name"
                                onChange={getInputData}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Last Name<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your last name"
                                name="last_name"
                                onChange={getInputData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Date of Birth
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="date_of_birth"
                                  value={
                                    data.date_of_birth
                                      ? dayjs(data.date_of_birth, "YYYY-MM-DD")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setData((prev) => ({
                                      ...prev,
                                      date_of_birth: date
                                        ? date.format("YYYY-MM-DD")
                                        : "",
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Age<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter your age"
                                name="age"
                                onChange={getInputData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Blood Group<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="blood_group"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select blood group</option>
                                <option value="A+">A+</option>
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Gender<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="gender"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select gender</option>
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                                <option value="OTHER">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Relation<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="relation"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select relation</option>
                                <option value="spouse">Spouse</option>
                                <option value="child">Child</option>
                                <option value="parent">Parent</option>
                                <option value="sibling">Sibling</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Birth Place<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your birthplace"
                                name="birthplace"
                                onChange={getInputData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Occupation
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="occupation"
                                onChange={getInputData}
                              >
                                <option value="">Select occupation</option>
                                <option value="employed">Employed</option>
                                <option value="self-employed">
                                  Self-employed
                                </option>
                                <option value="student">Student</option>
                                <option value="unemployed">Unemployed</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Dependent<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="dependants"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select dependent</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Mediclaim<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="mediclaim"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select mediclaim</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Country of Birth

                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                value="India"
                                readOnly
                                name="birth_country"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Nationality
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                value="Indian"
                                readOnly
                                name="nationality"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Aadhaar No
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your Aadhaar number"
                                maxLength={12}
                                pattern="\d*"
                                inputMode="numeric"
                                name="aadhar_no"
                                onChange={getInputData}
                                onKeyPress={(e) => {
                                  if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Address
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                rows={2}
                                placeholder="Enter contact address"
                                name="address"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                ID Type
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="id_type"
                                onChange={getInputData}
                              >
                                <option value="">Select ID Type</option>
                                <option value="aadhaar">Aadhaar</option>
                                <option value="passport">Passport</option>
                                <option value="voterid">Voter ID</option>
                                <option value="driverlicense">
                                  Driver License
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Personal ID
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your personal ID"
                                name="personal_id"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary custom_button">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Modal */}

      {/* Edit Modal */}
      <div
        className="modal fade"
        id="editexampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Edit Family Details
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editcloseModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleEdit}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                First Name<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your first name"
                                name="first_name"
                                value={editData.first_name || ""}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Last Name<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your last name"
                                name="last_name"
                                value={editData.last_name || ""}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Date of Birth
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="date_of_birth"
                                  value={
                                    editData.date_of_birth
                                      ? dayjs(
                                        editData.date_of_birth,
                                        "DD/MM/YYYY"
                                      )
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEditData((prev: any) => ({
                                      ...prev,
                                      date_of_birth: date
                                        ? date.format("DD/MM/YYYY")
                                        : "",
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  required
                                />

                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Age<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter your age"
                                name="age"
                                value={editData.age || ""}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Blood Group<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="blood_group"
                                value={editData.blood_group || ""}
                                onChange={getEditData}
                                required
                              >
                                <option value="">Select blood group</option>
                                <option value="A+">A+</option>
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Gender<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="gender"
                                value={editData.gender || ""}
                                onChange={getEditData}
                                required
                              >
                                <option value="">Select gender</option>
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                                <option value="OTHER">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Relation<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="relation"
                                value={editData.relation || ""}
                                onChange={getEditData}
                                required
                              >
                                <option value="">Select relation</option>
                                <option value="spouse">Spouse</option>
                                <option value="child">Child</option>
                                <option value="parent">Parent</option>
                                <option value="sibling">Sibling</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Birth Place<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your birthplace"
                                name="birthplace"
                                value={editData.birthplace || ""}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Occupation
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="occupation"
                                value={editData.occupation || ""}
                                onChange={getEditData}
                              >
                                <option value="">Select occupation</option>
                                <option value="employed">Employed</option>
                                <option value="self-employed">
                                  Self-employed
                                </option>
                                <option value="student">Student</option>
                                <option value="unemployed">Unemployed</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Dependent<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="dependants"
                                value={editData.dependants || ""}
                                onChange={getEditData}
                                required
                              >
                                <option value="">Select dependent</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Mediclaim<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="mediclaim"
                                value={editData.mediclaim || ""}
                                onChange={getEditData}
                                required
                              >
                                <option value="">Select mediclaim</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Country of Birth
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                value="India"
                                readOnly
                                name="birth_country"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Nationality
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                value="Indian"
                                readOnly
                                name="nationality"
                                onChange={getInputData}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Aadhaar No
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your Aadhaar number"
                                maxLength={12}
                                pattern="\d*"
                                inputMode="numeric"
                                name="aadhar_no"
                                value={editData.aadhar_no || ""}
                                onChange={getEditData}
                                onKeyPress={(e) => {
                                  if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Address
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                rows={2}
                                placeholder="Enter contact address"
                                name="address"
                                value={editData.address || ""}
                                onChange={getEditData}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                ID Type
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="id_type"
                                value={editData.id_type || ""}
                                onChange={getEditData}
                              >
                                <option value="">Select ID Type</option>
                                <option value="aadhaar">Aadhaar</option>
                                <option value="passport">Passport</option>
                                <option value="voterid">Voter ID</option>
                                <option value="driverlicense">
                                  Driver License
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Personal ID
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your personal ID"
                                name="personal_id"
                                value={editData.personal_id || ""}
                                onChange={getEditData}
                                
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Edit Modal */}
    </div>
  );
};

export default FamilyDetails;
